import { render } from "./Permission.vue?vue&type=template&id=8ceb67b2&scoped=true"
import script from "./Permission.vue?vue&type=script&lang=js"
export * from "./Permission.vue?vue&type=script&lang=js"

import "./Permission.vue?vue&type=style&index=0&id=8ceb67b2&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_mcn_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ceb67b2"]])

export default __exports__